<template>
  <div class="nopage">
    <div class="title">404</div>
    <div class="tips">
      SORRY,PAGE NOT FOUND
    </div>
    <!-- <div class="title">SPECIAL HOURS NOTICE</div>
    <div class="tips">We are CLOSED for private events during the following times:</div>
    <div v-for="(item, index) in config.closed_time" :key="index" class="time">
      {{ item.date }} {{ item.start_time }} - {{ item.end_time }}
    </div> -->
  </div>
</template>
<script>
import store from "@/store";
export default {
  data() {
    return {
      second: 5,
      time: null,
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {
    this.time = setInterval(() => {
      if (this.second == 0) {
        console.log("跳转走");
        clearInterval(this.time);
      } else {
        if (this.second > 0) {
          this.second = this.second - 1;
        }
      }
    }, 1000);
  },
};
</script>
<style scoped>
.nopage {
  width: 100%;
  height: 100vh;
  background: #f5d784;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title {
  background: #fff;
  width: 100px;
  height: 100px;
  border-radius: 100%;
  font-size: 2.4rem;
  font-weight: 500;
  text-align: center;
  line-height: 100px;
}
.tips {
  font-size: 1.8rem;
  color: #fff;
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.second {
  width: 30px;
  height: 30px;
  font-size: 1rem;
  background: #fff;
  color: #858181;
  border-radius: 100%;
  margin-left: 4px;
  text-align: center;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pageDisable.vue